import { useContext, useState, useEffect } from 'react';
import AppContext from '../contexts/AppContext';
import DataContext from '../contexts/DataContext';
import ConfigContext from '../contexts/ConfigContext';
import Input from './Input';
import Button from './Button';
import AnswerOptions from './AnswerOptions';
import { getQueryVariable } from './../helpers';

export default function EmailInput() {
  const {
    slides,
    currentSlide,
    goToNextSlide,
    updateSelectedOption,
    savedEmail,
    setSavedEmail,
    isNem3,
    getDataForNem3,
  } = useContext(AppContext);
  const { data, updateData } = useContext(DataContext);
  const { isDebrandedVersion, features } = useContext(ConfigContext);

  const [haveError, setHaveError] = useState(false);

  const validateEmail = (email: string): boolean => {
    return !!String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )?.length;
  };

  useEffect(() => {
    updateData({ ...data, sendEmailLink: slides[currentSlide].selectedValue });
    getDataForNem3();
  }, []);

  useEffect(() => {
    getDataForNem3();
  }, [isNem3]);

  return (
    <div>
      {features.showSunnyBot && <div className="my-[30px] md:my-10"></div>}
      {!features.showSunnyBot && (
        <p className="mt-[30px] md:mt-10 text-[17px] short:!text-[16px] md:text-[18px]">
          Email
        </p>
      )}
      <Input
        name="email"
        type="email"
        placeholder="Email address"
        onChange={(e: any) => {
          const email = e.currentTarget.value;
          if (validateEmail(email)) {
            updateSelectedOption(slides[currentSlide].key, email, 'email');
            updateData({
              ...data,
              email,
            });
            setHaveError(false);
          } else {
            updateSelectedOption(slides[currentSlide].key, null, 'email');
            updateData({
              ...data,
              email,
            });
            setHaveError(true);
          }
        }}
        onBlur={() => {
          if (data.email !== savedEmail) {
            saveEmail(data.email, data);
            setSavedEmail(data.email);
          }
        }}
        className="mt-3 md:mt-4 mb-6 md:mb-10 text-[#3c3c3c] md:w-[400px]"
        errorMessage="Enter a valid email."
        haveError={haveError}
        defaultValue={slides[currentSlide].additionalFields.email}
      />
      {!isDebrandedVersion && (
        <AnswerOptions
          options={slides[currentSlide].options}
          defaultValue={slides[currentSlide].selectedValue}
          updateSelectedOption={(newValue: any) => {
            const value =
              slides[currentSlide].selectedValue === newValue ? null : newValue;
            updateSelectedOption('emailLink', value);
            updateData({ ...data, sendEmailLink: value });
          }}
          slideKey={slides[currentSlide].key}></AnswerOptions>
      )}
      <div className="mt-[50px] md:mt-[60px]">
        <Button
          title="Continue"
          action={() => {
            dataLayer.push({ event: 'seform_email_entered' });
            goToNextSlide();
          }}
          disabled={!slides[currentSlide].additionalFields.email}></Button>
      </div>
    </div>
  );
}

const saveEmail = (email: string, data: any) => {
  let url = 'https://geoip.solarleadfactory.com/save-data/?email=';
  url += encodeURIComponent(email);
  url += '&lp-name=' + data.lpWizardId;
  url += '&state=' + data.selectedState;
  url += '&zip=' + data.selectedZipCode;
  url += '&city=' + data.selectedCity;
  url += '&street=' + encodeURIComponent(data.selectedAddress);
  url += '&property_type=' + encodeURIComponent(data.property);
  url += '&shade=' + encodeURIComponent(data.sunlight);
  url += '&ownership_status=' + encodeURIComponent(data.addressOwnership);
  url += '&email-report3=' + (data.sendEmailLink ? '1' : '0');
  url += '&ownership_status=' + encodeURIComponent(data.addressOwnership);
  url += '&electric_utility=' + data.utilityProvider;
  if (getQueryVariable('lsid') !== 'NA')
    url += '&lsid=' + getQueryVariable('lsid');

  var xmlhttp = new XMLHttpRequest();
  xmlhttp.onreadystatechange = function () {
    if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
    }
  };
  xmlhttp.open('GET', url, true);
  xmlhttp.send();
};
